import { portalPaths } from '@provision/portal-routes';
import { isNullish } from 'remeda';
import { usePartners } from 'src/graphql';
import { EntityNames } from 'src/graphql/types';
import { MAP_ENTITY_TO_URL_ENTITY } from 'src/pages/CustomViews/constants';
import { getPartnerFriendlyIdentifier } from 'src/routes/hooks';

export const useEntityFullUrl = (
  // `undefined` is tolerated so callers can pass partial fragment data; the hook
  // resolves to '' until the partner is known.
  partnerId: number | undefined,
  entityName:
    | EntityNames.Client
    | EntityNames.Site
    | EntityNames.Conversation
    | EntityNames.Project,
  entityId: string,
) => {
  const { partners = {} } = usePartners();

  const currentPartner = isNullish(partnerId) ? null : partners[partnerId];

  const getPath = {
    [EntityNames.Client]: portalPaths.client.full,
    [EntityNames.Site]: portalPaths.site.full,
    [EntityNames.Conversation]: portalPaths.conversation.full,
    [EntityNames.Project]: (id: string) =>
      portalPaths.entity.all({
        entityName: MAP_ENTITY_TO_URL_ENTITY[EntityNames.Project],
        id,
      }),
  }[entityName];

  return currentPartner && entityId
    ? `https://${window.location.host}/${getPartnerFriendlyIdentifier(currentPartner)}${getPath(entityId)}`
    : '';
};
